export enum PreOrderDataType {
    LIST,
    TEXT,
    PREVIOUSSAMPLE
}
